import * as salesforceService from './service';

const log = require("loglevel").getLogger("SalesforceManagerActions");
log.setLevel("error");

export const getSalesforceManagers = (callback) => {
  return async (dispatch) => {
    log.debug("SalesforceManagerActions -> getSalesforceManagers -> Enter");
    const result = await salesforceService.getSalesforceManagers();
    callback?.(result);
  }
};

export const saveSalesforceManager = ({ id, packageUrl, sandboxPackageUrl }, callback) => {
  return async (dispatch) => {
    log.debug("SalesforceManagerActions -> saveSalesforceManager -> Enter");
    const result = await salesforceService.saveSalesforceManager({ id, packageUrl, sandboxPackageUrl });
    callback?.(result);
  }
};